//Library Imports
import { useEffect, useState } from "react";
import { Collapse } from "antd";

// application components goes here
import Article from "./Article";
import { ReactComponent as ArrowDouble } from "../../../assets/img/icons/arrowDouble.svg";
import { IDesignArticleItem, IDesignItem } from "../Interfaces";

// styles goes here
import styled from "styled-components";

type ArticleListOrderProps = {
  design: IDesignItem;
  loading?: boolean;
};

const ArticleListOrder: React.FC<ArticleListOrderProps> = (props: ArticleListOrderProps) => {
  const [articles, setArticles] = useState(
    props.design.section !== undefined && props.design.section.length > 0 ? props.design.section[0].articles : []
  );
  useEffect(() => {
    setArticles(
      props.design.section !== undefined && props.design.section.length > 0 ? props.design.section[0].articles : []
    );
  }, [props.design.section]);

  // console.log("useEffect section Change", articles);
  return (
    <Wrapper className={`${props.loading ? "disabled" : ""}`}>
      <div className="sidebar-articles-wrap new-list">
        <header className="row py-2 mx-0">
          <div className="col-12 text-right pt-1">
            <p>
              Total Articles: <span>{articles.length}</span>
            </p>
          </div>
          <div className="col">
            <label className="drag-notic">
              <ArrowDouble />
              you can move articles up or down by simply drag and drop
            </label>
          </div>
        </header>
        <div className="articles-wrap card-body p-0 mb-3">
          <Collapse defaultActiveKey={["1"]}>
            {/* <Panel header="" key="1"> */}
            <div className="collapse in show" id="collapse-article-section-001122">
              <div className="per-right-articles">
                {articles &&
                  articles.map((article: IDesignArticleItem, index: number) => (
                    <Article key={index} dataIndex={index} article={article} />
                  ))}
              </div>
            </div>
            {/* </Panel> */}
          </Collapse>
        </div>
      </div>
    </Wrapper>
  );
};

export default ArticleListOrder;

const Wrapper = styled.div`
  .disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  .per-right-articles {
    .single-article-wrap {
      &:nth-of-type(1) {
        border-top: 0px;
      }
      .double-drag-icon {
        padding-left: 1px;
        cursor: grab;
        .fa-ellipsis-v {
          color: #cfdae8;
          font-size: 12px;
        }
      }
      .custom-control {
        .custom-control-label {
          &:before,
          &:after {
            width: 14px;
            height: 14px;
          }
        }
      }
      .actions {
        .custom-control {
          margin-right: 0;
        }
      }
      .non-action {
        transition: all ease-in-out 0.5s;
        .drag-overlay {
          background-color: rgba(255, 255, 255, 0.6);
          position: absolute;
          top: 100%;
          left: calc(50% - 15px);
          z-index: 99;
          cursor: grab;
          opacity: 0;
          transition: all ease-in-out 0.5s;
          img {
            max-width: 30px;
            display: block;
            margin: auto;
            margin-top: 16px;
          }
          svg {
            max-width: 30px;
            display: block;
            margin: auto;
            margin-top: 16px;
            height: 40px;
            width: 40px;
          }
        }
        &:hover {
          cursor: grab;
          .drag-overlay {
            opacity: 1;
            top: 25%;
          }
        }
      }
    }
  }
  .sidebar-articles-wrap.new-list {
    font-family: "robotomedium";
    header {
      color: #263153;
      border-bottom: solid 1px #b5c3d4;
      border-top: solid 1px #b5c3d4;
      .box-heading {
        font-size: 22px;
      }
      h2,
      p {
        margin-bottom: 0;
      }
      p {
        font-size: 16px;
        font-weight: 600;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
        }
      }
      .col-5 p {
        font-size: 14px;
      }
      .drag-notic {
        color: #37b0e9;
        font-size: 12px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 10px;
        }
      }
    }
    .articles-wrap {
      overflow: hidden;
      a.btn {
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
        font-weight: bold;
        color: #263153;
        display: block;
        text-align: left;
        i.fas,
        svg {
          float: right;
          font-size: 20px;
        }
      }
    }
  }
  .ant-collapse-item {
    .ant-collapse-header {
      width: 100%;
      padding-left: 12px !important;
      background: #fff;
      font-weight: bold;
      color: #263153 !important;
      display: block;
      text-align: left;
      font-size: 1rem;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
        line-height: 14px;
      }
      .anticon {
        right: 12px;
        left: auto !important;
        font-size: 14px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          top: 0px;
        }
        svg {
          transform: rotate(90deg) !important;
          path {
            stroke: #000;
            stroke-width: 60px;
          }
        }
      }
    }
    &.ant-collapse-item-active {
      .ant-collapse-header {
        .anticon svg {
          transform: rotate(270deg) !important;
        }
      }
    }
  }
`;
